import { Box, Flex } from '@chakra-ui/react';
import Marquee from 'react-fast-marquee';
import { quotes } from '@lib';
import { TestimonialCard } from './testimonial-card';

const topRow = quotes.filter((_, i) => i % 2 === 0);
const bottomRow = quotes.filter((_, i) => i % 2 !== 0);

const SPEED_DESKTOP = 40;

export function Testimonials(): JSX.Element {
  return (
    <>
      {/* Mobile */}
      <Box
        display={{ md: 'none' }}
        sx={{
          '.marquee': {
            minW: 'unset'
          }
        }}
      >
        <Marquee speed={30} gradient={false} delay={-16}>
          <Flex>
            {quotes.map(quote => (
              <TestimonialCard key={quote.name} {...quote} />
            ))}
          </Flex>
        </Marquee>
      </Box>

      {/* Tablet & Desktop */}
      <Box
        display={{ base: 'none', md: 'block' }}
        sx={{
          '.marquee': {
            minW: 'unset'
          },
          '.marquee-container': {
            overflowX: 'visible !important'
          }
        }}
      >
        <Marquee speed={SPEED_DESKTOP} gradient={false} delay={-16}>
          <Flex>
            {topRow.map(quote => (
              <TestimonialCard key={quote.name} {...quote} />
            ))}
          </Flex>
        </Marquee>

        <Marquee speed={SPEED_DESKTOP} gradient={false} delay={-18}>
          <Flex>
            {bottomRow.map(quote => (
              <TestimonialCard key={quote.name} {...quote} />
            ))}
          </Flex>
        </Marquee>
      </Box>
    </>
  );
}
